"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 34: BNROM / NINA-001
 * ------------------------------------------------------------------ */
// BNROM

function register(Mappers) {
  Mappers[34] = function (nes) {
    this.nes = nes;
  };

  Mappers[34].prototype = new Mappers[0]();

  Mappers[34].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    this.load32kRomBank(value & 0x03, 0x8000);
  };

  Mappers[34].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("BNROM: Invalid ROM! Unable to load.");
    }

    this.reset();
    // The board powers on with the last 32 KB bank mapped in.
    this.load32kRomBank(this.nes.rom.romCount / 2 - 1, 0x8000);
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };
}

module.exports = { register: register };
